import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

// Serving sizes come back 100 to a page, ordered by name and then created date.
function useServingSizes(establishmentId, page = 1) {
  const queryReturnValues = useQuery(
    ["serving-sizes", { establishmentId, page }],
    inventoryClient.getServingSizesPaginated,
    {
      keepPreviousData: true,
      staleTime: 1000 * 60 * 10,
    }
  );

  return queryReturnValues;
}

export default useServingSizes;
